import { mbiSchema, requiredErrorMessage } from '@common/schema';
import * as yup from 'yup';
import { isCashPaymentType } from '../utils';

export const medicareInsuranceEntrySchema = yup.object().shape({
  id: yup.string().optional(),

  payer_name: yup
    .object({
      id: yup
        .string()
        .required(requiredErrorMessage)
        .min(1, requiredErrorMessage),
      name: yup
        .string()
        .required(requiredErrorMessage)
        .min(1, requiredErrorMessage),
    })
    .required(requiredErrorMessage),
  payer_type: yup.string().when('payment_type', {
    is: isCashPaymentType,
    then: schema => schema.notRequired(),
    otherwise: schema => schema.required(requiredErrorMessage),
  }),
  mbi: mbiSchema.when('payment_type', {
    is: isCashPaymentType,
    then: schema => schema.notRequired(),
    otherwise: schema => schema.required(requiredErrorMessage),
  }),
  payment_type: yup.string().required(requiredErrorMessage),
});
